import { Box, Skeleton, Stack, Grid } from "@mui/material";

function SkeletonCard({ height = 120 }) {
    return (
        <Box
            sx={{
                p: 2,
                borderRadius: "20px",
                bgcolor: "#ffffff",
                border: "1px solid rgba(17,24,39,0.06)",
                boxShadow: "0 10px 30px rgba(17,24,39,0.05)",
            }}
        >
            <Skeleton
                variant="text"
                width="42%"
                height={30}
                sx={{ mb: 1, transform: "none" }}
            />
            <Skeleton
                variant="text"
                width="68%"
                height={22}
                sx={{ mb: 2, transform: "none" }}
            />
            <Skeleton
                variant="rounded"
                width="100%"
                height={height}
                sx={{ borderRadius: "14px" }}
            />
        </Box>
    );
}

function MiniStatCard() {
    return (
        <Box
            sx={{
                p: 2,
                borderRadius: "18px",
                bgcolor: "#ffffff",
                border: "1px solid rgba(17,24,39,0.06)",
                boxShadow: "0 10px 30px rgba(17,24,39,0.05)",
                minHeight: 110,
            }}
        >
            <Skeleton
                variant="circular"
                width={36}
                height={36}
                sx={{ mb: 1.5 }}
            />
            <Skeleton
                variant="text"
                width="52%"
                height={20}
                sx={{ transform: "none" }}
            />
            <Skeleton
                variant="text"
                width="76%"
                height={28}
                sx={{ transform: "none" }}
            />
        </Box>
    );
}

export default function HomeSkeletonPage() {
    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
                // bgcolor: "#F7F8FC",
                px: { xs: 2, sm: 3, md: 4 },
                py: { xs: 2, sm: 3, md: 4 },
            }}
        >
            <Stack spacing={{ xs: 2, md: 3 }}>
                {/* Header */}
                <Box
                    sx={{
                        p: { xs: 2, md: 3 },
                        borderRadius: "24px",
                        background: "linear-gradient(135deg, #902348 0%, #B53D67 100%)",
                        boxShadow: "0 18px 40px rgba(144,35,72,0.20)",
                    }}
                >
                    <Skeleton
                        variant="text"
                        width="30%"
                        height={24}
                        sx={{
                            bgcolor: "rgba(255,255,255,0.28)",
                            transform: "none",
                            mb: 1,
                            minWidth: 120,
                        }}
                    />
                    <Skeleton
                        variant="text"
                        width="58%"
                        height={42}
                        sx={{
                            bgcolor: "rgba(255,255,255,0.28)",
                            transform: "none",
                            mb: 1,
                            maxWidth: 420,
                        }}
                    />
                    <Skeleton
                        variant="text"
                        width="72%"
                        height={24}
                        sx={{
                            bgcolor: "rgba(255,255,255,0.22)",
                            transform: "none",
                            maxWidth: 540,
                        }}
                    />
                </Box>

                {/* Stats */}
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                        <MiniStatCard />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <MiniStatCard />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <MiniStatCard />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <MiniStatCard />
                    </Grid>
                </Grid>

                {/* Main content */}
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={8}>
                        <SkeletonCard height={260} />
                    </Grid>

                    <Grid item xs={12} lg={4}>
                        <Stack spacing={2}>
                            <SkeletonCard height={90} />
                            <SkeletonCard height={90} />
                        </Stack>
                    </Grid>
                </Grid>

                {/* Table area */}
                <Box
                    sx={{
                        p: { xs: 2, md: 3 },
                        borderRadius: "20px",
                        bgcolor: "rgba(255,255,255,0.22)",
                        border: "1px solid rgba(17,24,39,0.06)",
                        boxShadow: "0 10px 30px rgba(17,24,39,0.05)",
                    }}
                >
                    <Skeleton
                        variant="text"
                        width="22%"
                        height={32}
                        sx={{ transform: "none", mb: 2, minWidth: 140 }}
                    />

                    <Stack spacing={1.25}>
                        {Array.from({ length: 6 }).map((_, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "1.2fr 0.8fr",
                                        sm: "1.4fr 0.9fr 0.7fr",
                                        md: "2fr 1fr 1fr 1fr",
                                    },
                                    gap: 1.5,
                                    alignItems: "center",
                                }}
                            >
                                <Skeleton variant="rounded" height={18} sx={{ borderRadius: "8px" }} />
                                <Skeleton variant="rounded" height={18} sx={{ borderRadius: "8px" }} />
                                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                                    <Skeleton variant="rounded" height={18} sx={{ borderRadius: "8px" }} />
                                </Box>
                                <Box sx={{ display: { xs: "none", md: "block" } }}>
                                    <Skeleton variant="rounded" height={18} sx={{ borderRadius: "8px" }} />
                                </Box>
                            </Box>
                        ))}
                    </Stack>
                </Box>
            </Stack>
        </Box>
    );
}